import { Component, OnInit,AfterViewInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UtilityService } from '../services/utility.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { DataTransferService } from '../services/data-transfer.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
 
 
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit, AfterViewInit  {
 
 
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
 
  reports: Report[] = [];
  reportParent: any;
  displayedColumns: string[] = ['ReportName', 'ReportDescription', 'StartDate', 'EndDate', 'extract'];
  dataSource = new MatTableDataSource<any>();
  startDate: any = new Date();
  tableauLink = "https://tableau.honeywell.com/t/HBT/views/";
  showReport: boolean = false;
  isTableauReport: boolean = false;
reportUrl!: SafeResourceUrl;
  constructor(private utilityService: UtilityService, private route: ActivatedRoute,
    private router: Router, private userService: UserService,private dataTransfer:DataTransferService,
    private sanitizer: DomSanitizer) { }
 
  ngOnInit() {
    this.dataTransfer.myMethod(true);
    this.reportParent = this.route.snapshot.paramMap.get('id')
    this.viewReportConfigurations();
    /*  this.reports.push({ 'Report': "Interaction",'ReportId':"Interaction" })
     this.reports.push({ 'Report': "Workorder Exceptions",'ReportId':"WO_Exceptions" }) */
    /*   this.dataSource.data = this.reports; */
  }
  ngAfterViewInit() {
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;
}
 
 viewReportConfigurations() {
 
    this.userService.viewReportConfig(this.utilityService.currentUtility.OfficeId, this.reportParent, this.utilityService.currentUtility.LoggedInUserRole).subscribe(data => {
      if (data.length > 0) {
        this.userService.getAllReportList(this.reportParent).subscribe(reportConfigs => {
          data.forEach(element => {
            console.log('reportParent:', this.reportParent);
            if (element.StartDate != null || element.StartDate != undefined) {
              element.StartDate = new Date(element.StartDate);
            }
 
 
            const config = reportConfigs.find(r => r.ReportId === element.ReportId);
 
            if (config) {
              element.DateControlParameter = config.DateControlParameter;
            }
            console.log(reportConfigs);
          });
          //  this.dataSource.paginator = this.firstpaginator;
          this.dataSource.data = data;
          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          });
 
        });
 
      }
 
 
    });
 
  }
  reportExtractClick(reportData: any) {
 
  let reportLink = '';
  let officeParams = '';
 
  const start = reportData.StartDate
    ? moment(reportData.StartDate)
    : null;
 
  const end = reportData.EndDate
    ? moment(reportData.EndDate).add(1, 'days')
    : null;
 
  const useDateFilter =
    reportData.DateControlParameter === true &&
    start &&
    end;
 
  this.userService.authorizeReports(
    reportData.ReportId,
    this.utilityService.currentUtility.OfficeId
  ).subscribe(res => {
 
    if (!res) {
      return;
    }
 
    if (!reportData.ReportPath) {
      Swal.fire({
        text: 'Path not available',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }
 
    // Office parameter
    officeParams =
      this.utilityService.currentUtility.Source === 'BBCS'
        ? this.utilityService.currentUtility.OfficeId
        : this.utilityService.currentUtility.ProgramsponsorDescription;
 
    // Detect Power BI report
    const isPowerBI =
      reportData.ReportPath.toLowerCase().includes('powerbi');
 
    if (isPowerBI) {
 
      // Always filter by Office
      let filter = `Query1/OFFICEID eq '${officeParams}'`;
 
      // Add Date filter only when enabled
      if (useDateFilter) {
 
        filter +=
          ` and Query1/STARTDATE ge datetime'${start.format('YYYY-MM-DD')}T00:00:00'` +
          ` and Query1/STARTDATE le datetime'${end.format('YYYY-MM-DD')}T00:00:00'`;
      }
 
      reportLink =
        reportData.ReportPath +
        '&filter=' +
        encodeURIComponent(filter) +
        '&filterPaneEnabled=false';
        console.log('================ POWER BI URL ================');
        console.log(reportLink);
        console.log('==============================================');
      this.isTableauReport = false;
      this.reportUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(reportLink);
      this.showReport = true;
    }
    else {
 
      // Tableau Report
      reportLink =
        reportData.ReportPath +
        '?OfficeId=' +
        encodeURIComponent(officeParams);
 
      // Add dates only when DateControlParameter = true
      if (useDateFilter) {
 
        reportLink +=
          '&StartDate=' +
          start.format('YYYY-MM-DD') +
          '&EndDate=' +
          end.format('YYYY-MM-DD');
      }
 
      reportLink +=
        '&:showShareOptions=false' +
        '&iframeSizedToWindow=true' +
        '&:embed=y' +
        '&:showAppBanner=false' +
        '&:display_count=no' +
        '&:showVizHome=no';
        console.log('================ TABLEAU URL ================');
        console.log(reportLink);
        console.log('=============================================');
      localStorage.setItem('tableauLink', reportLink);
      this.router.navigateByUrl('/Reports');
    }
  });
}
 

 
goBackToTable() {
  this.showReport = false;
}
}
export class Report {
  public Report: string;
  public ReportId: string;
}